(function () {
  if (window.customElements.get('card-quick-add')) return;

  class CardQuickAdd extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.card-quick-add__trigger');
      this.overlay = this.querySelector('.card-quick-add__overlay');
      this.closeBtn = this.querySelector('.card-quick-add__close');
      this.form = this.querySelector('.card-quick-add__form');
      this.cartBtn = this.querySelector('.card-quick-add__cart');
      this.cartText = this.querySelector('.card-quick-add__cart-text');
      this.variantInput = this.form.querySelector('input[name="id"]');
      this.dataScript = this.querySelector('.card-quick-add__data');

      try {
        this.variants = JSON.parse(this.dataScript.textContent);
      } catch (e) {
        this.variants = [];
        return;
      }

      // Determine number of options from any variant
      this.numOptions = this.variants[0] && this.variants[0].options ? this.variants[0].options.length : 0;

      // Initialize selected options from first available (or first) variant
      const initial = this.variants.find((v) => v.available) || this.variants[0];
      this.selected = initial ? [...initial.options] : [];

      // Bind events
      this.trigger.addEventListener('click', this._open.bind(this));
      this.closeBtn.addEventListener('click', this._close.bind(this));
      this.form.addEventListener('submit', this._submit.bind(this));
      this.querySelectorAll('.card-quick-add__option-btn').forEach((btn) => {
        btn.addEventListener('click', this._onOptionClick.bind(this));
      });

      this._refreshUI();
    }

    _open(e) {
      e.preventDefault();
      e.stopPropagation();
      this.overlay.hidden = false;
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    _close(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.overlay.hidden = true;
      this.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
    }

    _onOptionClick(e) {
      e.preventDefault();
      const btn = e.currentTarget;
      const position = parseInt(btn.dataset.optionPosition, 10) - 1;
      const value = btn.dataset.optionValue;
      this.selected[position] = value;
      this._refreshUI();
    }

    _findVariant() {
      return this.variants.find((v) => {
        return v.options.every((opt, i) => opt === this.selected[i]);
      });
    }

    _refreshUI() {
      // Mark selected option buttons
      this.querySelectorAll('.card-quick-add__option-btn').forEach((btn) => {
        const position = parseInt(btn.dataset.optionPosition, 10) - 1;
        const value = btn.dataset.optionValue;
        btn.classList.toggle('is-selected', this.selected[position] === value);
      });

      const variant = this._findVariant();
      if (variant) {
        this.variantInput.value = variant.id;
        const available = variant.available;
        this.cartBtn.disabled = !available;
        this.cartText.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
      } else {
        this.cartBtn.disabled = true;
        this.cartText.textContent = 'UNAVAILABLE';
      }
    }

    async _submit(e) {
      e.preventDefault();
      if (this.cartBtn.disabled) return;

      const formData = new FormData(this.form);
      this.classList.add('is-loading');
      this.cartText.textContent = 'ADDING...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'Add to cart failed');
        }
        const item = await res.json();
        this._afterAdd(item);
      } catch (err) {
        console.error('[card-quick-add]', err);
        this.cartText.textContent = 'ERROR';
        setTimeout(() => {
          this.classList.remove('is-loading');
          this._refreshUI();
        }, 1500);
      }
    }

    _afterAdd(item) {
      this.classList.remove('is-loading');
      this._close();
      this._refreshUI();

      // Refresh /cart.js so themes that read it update
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          // Update cart bubble (handles both Impulse selectors)
          document
            .querySelectorAll('.cart-link__bubble-num, .cart-link__bubble')
            .forEach((el) => {
              if (el.children.length === 0) el.textContent = cart.item_count;
              el.classList.add('cart-link__bubble--visible');
            });

          // Trigger Impulse cart drawer events (multiple fallbacks)
          this._triggerCartDrawer(item, cart);
        })
        .catch(() => this._triggerCartDrawer(item));
    }

    _triggerCartDrawer(item, cart) {
      // 1. Custom event for any listeners
      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', { detail: { item, cart }, bubbles: true })
      );

      // 2. jQuery event Impulse listens for
      if (window.jQuery) {
        window.jQuery.event.trigger({ type: 'added.ajaxProduct', variant: item });
      }

      // 3. Impulse-specific globals
      if (window.theme && window.theme.cart && typeof window.theme.cart.refresh === 'function') {
        window.theme.cart.refresh();
      }
      if (window.theme && window.theme.CartForm && typeof window.theme.CartForm.refresh === 'function') {
        window.theme.CartForm.refresh();
      }

      // 4. Fallback: click the cart drawer toggle
      const toggle = document.querySelector(
        '[data-drawer-toggle="cart"], [data-cart-toggle], .site-header__cart, [data-cart-drawer-toggle]'
      );
      if (toggle && (!window.jQuery || !window.theme)) {
        toggle.click();
      }
    }
  }

  window.customElements.define('card-quick-add', CardQuickAdd);
})();